import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@shared/composables/useAuth.js'

// Import views
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import MembersView from '../views/MembersView.vue'
import MemberDetailView from '../views/MemberDetailView.vue'
import MemberFormView from '../views/MemberFormView.vue'
import PlansView from '../views/PlansView.vue'
import PaymentsView from '../views/PaymentsView.vue'
import SettingsView from '../views/SettingsView.vue'
import MessageHistoryView from '../views/MessageHistoryView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/members',
    name: 'members',
    component: MembersView,
    meta: { requiresAuth: true },
  },
  {
    path: '/members/new',
    name: 'member-new',
    component: MemberFormView,
    meta: { requiresAuth: true },
  },
  {
    path: '/members/:id',
    name: 'member-detail',
    component: MemberDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: '/members/:id/edit',
    name: 'member-edit',
    component: MemberFormView,
    meta: { requiresAuth: true },
  },
  {
    path: '/plans',
    name: 'plans',
    component: PlansView,
    meta: { requiresAuth: true },
  },
  {
    path: '/payments',
    name: 'payments',
    component: PaymentsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessageHistoryView,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard - check authentication
router.beforeEach(async (to, from, next) => {
  const { isAuthenticated, fetchMe, user } = useAuth()
  const { apiClient } = await import('@shared/utils/apiClient.js')

  // Going to login page - always allow (prevents redirect loops)
  if (to.name === 'login') {
    // If already authenticated, redirect away from login
    if (isAuthenticated.value && user.value) {
      next({ name: 'dashboard' })
      return
    }
    // Not authenticated or no user loaded - show login page
    next()
    return
  }

  // Route requires auth
  if (to.meta.requiresAuth) {
    // Check if token exists
    if (!apiClient.isAuthenticated()) {
      // No token - redirect to login
      next({ name: 'login', query: { redirect: to.fullPath } })
      return
    }

    // Token exists, fetch user info if not loaded
    if (!user.value) {
      try {
        await fetchMe()
      } catch (error) {
        // Failed to fetch user (token invalid) - redirect to login
        // Clear token to prevent loop
        apiClient.clearToken()
        next({ name: 'login', query: { redirect: to.fullPath } })
        return
      }
    }
  }

  next()
})

export default router
